(function () {
  'use strict';

  class AccountSetupSuccessController extends Controllers.BaseControllerES6 {

    // @ngInject
    constructor($scope, $injector, $timeout, AnalyticsService, UIUtils) {
      super($scope, $injector);
      this.__objectType = 'AccountSetupWaitingController';

      this.$timeout = $timeout;
      this.AnalyticsService = AnalyticsService;
      this.UIUtils = UIUtils;
    }

    downloadCSV($event) {
      let url = 'https://s3.amazonaws.com/honeybook_cdn/account_setup/Open_Invoice_Transfer_Template.csv';
      this.UIUtils.downloadFileFromLink($event, url, this.AnalyticsService.analytics_events.account_setup_export_csv);
    }

    close() {
      this.btnClick();
    }
  }

  Components.AccountSetupSuccess = {
    bindings: {
      btnClick: '&'
    },
    controller: AccountSetupSuccessController,
    name : 'hbAccountSetupWaiting',
    templateUrl: 'angular/app/modules/core/features/account_setup/account_setup_success_template.html',
  };

}());